import * as BABYLON from '@babylonjs/core';
import Iterator from '../core/Iterator';
export default class BabylonMeshesCombiner{
	constructor({scene}){
		this._scene=scene;
		this._mapMaterialNameToCombinedMesh = new Map();
		this.combineMeshesByMaterial = this.combineMeshesByMaterial.bind(this);
		this._get_MaterialName_MeshesToCombine_Pairs= this._get_MaterialName_MeshesToCombine_Pairs.bind(this);
		this._validateAllVerticesHaveBufferBound= this._validateAllVerticesHaveBufferBound.bind(this);
		this._get_getName = this._get_getName.bind(this);
		this._mergeMeshes= this._mergeMeshes.bind(this);
	}
	combineMeshesByMaterial(babylonMeshes){
		const getName = this._get_getName();
		const materialName_MeshesToCombine_Pairs= this._get_MaterialName_MeshesToCombine_Pairs(babylonMeshes);
		for(var pair of materialName_MeshesToCombine_Pairs){
			let  [materialName, meshesToCombine]=pair;
			//if(materialName=='VG_Ext_Brick_IbstockSurreyOrange (Instance)'){
			console.log('materialName: '+materialName);
			console.log(meshesToCombine);
			if(materialName==='VG_Ext_Brick_IbstockSurreyOrange')continue;
			if(meshesToCombine.length>500)continue;
			let combinedMesh = this._mapMaterialNameToCombinedMesh.get(materialName);
			if(combinedMesh!==undefined&&combinedMesh!==null){
				meshesToCombine = [combinedMesh].concat(meshesToCombine);
			}
			if(meshesToCombine.length<2){
				continue;
			}
			combinedMesh = this._mergeMeshes(getName(), meshesToCombine, this._scene);
			if(combinedMesh===null){
				continue;
			}
			this._mapMaterialNameToCombinedMesh.set(materialName, combinedMesh);
		}
	}
	_get_getName(){
		let nMerge=0;
		return ()=>{
			return 'merged_'+(nMerge++);
		};
	}
	_get_MaterialName_MeshesToCombine_Pairs(babylonMeshes){
		const mapMeshNameToMeshesToCombine = new Map();
		const materialName_MeshesToCombine_Pairs = [];
		for(var babylonMesh of babylonMeshes){
			const materialName = babylonMesh.material?.name;
			let meshesToCombine = mapMeshNameToMeshesToCombine.get(materialName);
			if(meshesToCombine===undefined||meshesToCombine===null){
				meshesToCombine = [babylonMesh];
				materialName_MeshesToCombine_Pairs.push([materialName, meshesToCombine]);
				mapMeshNameToMeshesToCombine.set(materialName, meshesToCombine);
			}
			else
				meshesToCombine.push(babylonMesh);
		}
		return materialName_MeshesToCombine_Pairs;
	}
	
	
	_mergeMeshes(meshName, meshes, scene) {
		if(meshes.length<2)return;
		const firstMesh = meshes[0];
		let newUv2s = [];
		let newColors = [];
		let newMatricesIndices = [];
		let newMatricesWeights = [];
		let newIndices = [];
		let newPositions = [];
		let newNormals = [];
		let newUvs = [];
		let meshesToDispose = [];
		var hasUv2s = true;
		var hasColors = true;
		var hasMatricesIndices = true;
		var hasMatricesWeights = true;
		let hasNormals =true;
		const normalsForEachMesh=[];
		for (var i = 0; i < meshes.length; i++) {
			const mesh = meshes[i];
			const normals = mesh.getVerticesData(BABYLON.VertexBuffer.NormalKind);
			if(!normals)
				hasNormals = false;
			normalsForEachMesh[i]=normals;
			if (!mesh.isVerticesDataPresent([BABYLON.VertexBuffer.UV2Kind])) hasUv2s = false;
			if (!mesh.isVerticesDataPresent([BABYLON.VertexBuffer.ColorKind])) hasColors = false;
			if (!mesh.isVerticesDataPresent([BABYLON.VertexBuffer.MatricesIndicesKind])) hasMatricesIndices = false;
			if (!mesh.isVerticesDataPresent([BABYLON.VertexBuffer.MatricesWeightsKind])) hasMatricesWeights = false;
		
		}
		for (i = 0; i < meshes.length; i++) {
			const mesh = meshes[i];
			try{
				var indices = mesh.getIndices();
				if(indices===null)continue;
				const positions = mesh.getVerticesData(BABYLON.VertexBuffer.PositionKind);
				if(positions===null)continue;
				mesh.computeWorldMatrix(true);
				newUvs = newUvs.concat(mesh.getVerticesData(BABYLON.VertexBuffer.UVKind));
				if (hasUv2s) newUv2s = newUv2s.concat(mesh.getVerticesData(BABYLON.VertexBuffer.UV3Kind));
				if (hasColors) newColors = newColors.concat(mesh.getVerticesData(BABYLON.VertexBuffer.ColorKind));
				if (hasMatricesIndices) newMatricesIndices = newMatricesIndices.concat(mesh.getVerticesData(BABYLON.VertexBuffer.MatricesIndicesKind));
				if (hasMatricesWeights) newMatricesWeights = newMatricesWeights.concat(mesh.getVerticesData(BABYLON.VertexBuffer.MatricesWeightsKind));

				var positionsOffset = newPositions.length / 3;

				var worldMatrix = mesh.getWorldMatrix();
				this._validateAllVerticesHaveBufferBound(indices, positions);
				for (var vertexIndex = 0; vertexIndex <  positions.length; vertexIndex += 3) {
					const vertex = BABYLON.Vector3.TransformCoordinates(new BABYLON.Vector3(positions[vertexIndex], positions[vertexIndex + 1], positions[vertexIndex + 2]), worldMatrix);
					newPositions.push(vertex.x);
					newPositions.push(vertex.y);
					newPositions.push(vertex.z);
				}
				if(hasNormals){
					const normals = normalsForEachMesh[i];
					if(normals===null){
						normals = new Array(positions.length/3/*???*/).fill(0);
					}
					for (var normalsIndex = 0; normalsIndex != normals.length; normalsIndex += 3) {
						var normal = BABYLON.Vector3.TransformNormal(new BABYLON.Vector3(normals[normalsIndex], normals[normalsIndex + 1], normals[normalsIndex + 2]), worldMatrix);
						newNormals.push(normal.x);
						newNormals.push(normal.y);
						newNormals.push(normal.z);
					}
				}
				for (var indicesIndex = 0; indicesIndex < indices.length; indicesIndex++) {
				  newIndices.push(indices[indicesIndex] + positionsOffset);
				}
			}
			finally{
				if(i>0)
					meshesToDispose.push(mesh);
			}
		}
		if((newIndices.length<1)||(newPositions.length<1))return null;
		const newMesh = new BABYLON.Mesh(meshName, scene);
		newMesh.setVerticesData(BABYLON.VertexBuffer.PositionKind, newPositions, false);
		if(hasNormals&&(newNormals.length>0))
			newMesh.setVerticesData(BABYLON.VertexBuffer.NormalKind, newNormals, false);
		newMesh.setVerticesData(BABYLON.VertexBuffer.UVKind, newUvs, false);
		
		if (newUv2s.length > 0) newMesh.setVerticesData(BABYLON.VertexBuffer.UV2Kind, newUv2s, false);
		if (newColors.length > 0) newMesh.setVerticesData(BABYLON.VertexBuffer.ColorKind, newUvs, false);
		if (newMatricesIndices.length > 0) newMesh.setVerticesData(BABYLON.VertexBuffer.MatricesIndicesKind, newUvs, false);
		if (newMatricesWeights.length > 0) newMesh.setVerticesData(BABYLON.VertexBuffer.MatricesWeightsKind, newUvs, false);

		newMesh.setIndices(newIndices);
		newMesh.material = firstMesh.material;
		console.log( firstMesh.material);
		meshesToDispose.forEach(mesh=>mesh.dispose(true));
		firstMesh.dispose(true);
		return newMesh;
	}
	_validateAllVerticesHaveBufferBound(indices, positions){
		
	}
}